<template>
  <section class="py-12 text-center" style="background-color: #047857;">
    <div class="container mx-auto px-4" v-bind="getAOSAttrs('fade-up', 100)">
      <h2 class="font-weight-600 mb-6 header" style="color: #fef9c3;">You focus on the product, We'll do the Co-Packing.</h2>
      
      <p class="max-w-3xl mx-auto mb-10 content" style="color: #f3f4f6; font-size: 1.375rem;">
        Any company that needs to beat their rival needs to have a highly capable packaging company besides them offering 
        them the most meaningful and cost-effective solutions to all their preferences and needs.
      </p>
      
      <div class="space-y-3 mb-6">
        <p class="question" style="color: #ffffff;">To Request A Quote,</p>
        <p class="question" style="color: #ffffff;">A Dieline Template Or A Sample?</p>
        <p class="question" style="color: #ffffff;">Or Any Other Questions?</p>
      </div>
      
      <div class="mb-10">
        <p class="email-prefix" style="color: #ffffff;">
          Email Us At: 
          <a href="mailto:sales@leaflypackaging.com" class="hover:underline inline-block py-2" style="min-height: 44px; display: inline-flex; align-items: center; color: #fef9c3;">
            sales@leaflypackaging.com
          </a>
        </p>
      </div>
      
      <div class="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
        <nuxt-link :to="'/faqs.html'" class="faq-button inline-block min-w-[200px] py-4 px-6 border-2 border-white rounded-full bg-transparent font-weight-600 transition-colors duration-300" style="min-height: 56px; display: inline-flex; align-items: center; justify-content: center; color: #ffffff;">
          FAQ
        </nuxt-link>
        <nuxt-link :to="'/contact-us'" class="inline-block min-w-[200px] py-4 px-6 bg-yellow-400 rounded-full text-gray-900 font-weight-600 hover:bg-yellow-300 transition-colors duration-300" style="min-height: 56px; display: inline-flex; align-items: center; justify-content: center;">
          GET QUOTE
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { getAOSAttrs } = useAOS()
</script>

<style scoped lang="scss">
.header {
    font-size: 3rem;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 12px;
}
.content {
    font-weight: 400;
    line-height: 1.3;
}
.question{
    font-size: 2rem;
    word-spacing: 0.4em;
}
.email-prefix{
    word-spacing: 0.4em;
    font-size: 2rem;
}

@media (max-width: 768px) {
    .header {
        font-size: 2rem;
    }
    .content {
        font-size: 1.125rem;
    }
    .question {
        font-size: 1.5rem;
    }
    .email-prefix {
        font-size: 1.5rem;
    }
}

.faq-button {
    &:hover {
        background-color: #ffffff !important;
        color: #047857 !important;
    }
}
</style> 